import React, { Component } from 'react'
import { Link } from 'react-router-dom';
//import Stats from './Stats';
import Pigments from './components/Picker/Pigments';
import Oils from './components/Picker/Oils';
import Palette from './components/Picker/Palette';
import History from './components/Picker/History';
import '../css/App.css';
import axios from 'axios';
import classNames from 'classnames';

class Picker extends Component {

    constructor(props) {
        super(props)

        this.state = {
            medianBlur: false,
            canvas: null,
            context: null,
            red: 0,
            blue: 0,
            green: 0,
            hex: '#ffffff',
            hexSaved: null,
            hsv: { h: 0, s: 0, v: 0 },
            hsvSaved: { h: 0, s: 0, v: 0 },
            hexHistory: [],
            palette: [],
            quadrant: 1,
            huePigments: {}, // R, O, Y, G/Y, G, B/G, B, P/B, P, R/P
            neutralPigments: {}, // Raw Umber, Black,
            cart: [],
            cartOpen: false,
            loadingPigments: false,
            tool: 'palette', // palette, dropper, move
            //clickAudio: new Audio('fart.wav')
        }

        this.getColorByMouse = this.getColorByMouse.bind(this);
        this.findPos = this.findPos.bind(this);
        this.storeHsv = this.storeHsv.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.clickMedian = this.clickMedian.bind(this);
        this.restoreSaved = this.restoreSaved.bind(this);
        this.addToPalette = this.addToPalette.bind(this);
        this.handleMouseClick = this.handleMouseClick.bind(this);
        this.handleCanvasClick = this.handleCanvasClick.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.toggleCart = this.toggleCart.bind(this);
        this.changeTool = this.changeTool.bind(this);
        this.removePigment = this.removePigment.bind(this);
        this.redraw = this.redraw.bind(this);
        this.zoom = this.zoom.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.loadCanvas = this.loadCanvas.bind(this);
    }

    componentDidMount() {
        var _this = this;
        //Get the canvas element by using the getElementById method.
        var canvas = document.getElementById('my_canvas');
        canvas.style.width ='100%';
        canvas.style.height ='100%';
        canvas.width  = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        var lastX = canvas.width / 2, lastY = canvas.height / 2;
        var dragStart, dragged;

        //Get a 2D drawing context for the canvas.
        var context = canvas.getContext('2d');
        this.trackTransforms(context);

        canvas.addEventListener('mousedown', function(evt) {
            if (_this.state.tool === 'move') {
                document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
                lastX = evt.offsetX || (evt.pageX - canvas.offsetLeft);
                lastY = evt.offsetY || (evt.pageY - canvas.offsetTop);
                dragStart = context.transformedPoint(lastX, lastY);
                dragged = false;
                _this.setState({
                    lastX: lastX,
                    lastY: lastY,
                    dragStart: dragStart,
                    dragged: dragged,
                    medianBlur: false
                });
            } else {
                _this.handleCanvasClick(evt);
            }
        }, false);
        
        canvas.addEventListener('mousemove', function(evt) {
            if (_this.state.tool === 'move') {
                lastX = evt.offsetX || (evt.pageX - canvas.offsetLeft);
                lastY = evt.offsetY || (evt.pageY - canvas.offsetTop);
                if (_this.state.dragStart){
                    var pt = context.transformedPoint(lastX, lastY);
                    context.translate(pt.x-_this.state.dragStart.x, pt.y-_this.state.dragStart.y);
                    _this.redraw();
                }
                _this.setState({
                    lastX: lastX,
                    lastY: lastY,
                    dragged: true
                });
            } else {
                _this.getColorByMouse(evt);
            }
        }, false);
        
        canvas.addEventListener('mouseup',function(evt) {
            if (_this.state.tool === 'move') {
                _this.setState({
                    dragStart: null
                });
                if (!_this.state.dragged) _this.zoom(evt.shiftKey ? -1 : 1 );
            }
        },false);

        //canvas.addEventListener('DOMMouseScroll', _this.handleScroll, false);
        //canvas.addEventListener('mousewheel', _this.handleScroll, false);
        
        this.setState({
            canvas: canvas,
            context: context
        });
        this.loadCanvas(this.props.image);
    }

    zoom(clicks) {
        var pt = this.state.context.transformedPoint(this.state.lastX, this.state.lastY);
        this.state.context.translate(pt.x, pt.y);
        // Zoom In
        //var factor = Math.pow(1.1, clicks);
        //this.state.context.scale(factor, factor);
        this.state.context.translate(-pt.x, -pt.y);
        this.redraw();
    }

    handleScroll(evt) {
        var delta = evt.wheelDelta ? evt.wheelDelta / 40 : evt.detail ? -evt.detail : 0;
        if (delta) this.zoom(delta);
        return evt.preventDefault() && false;
    }

    loadCanvas(dataUrl) {
        var _this = this;
        var x = 0;
        var y = 0;

        if (this.state.loadedImage) {
            _this.state.context.drawImage(this.state.loadedImage, x, y);
        } else {
            //Create a new Image object.
            var imgObj = new Image();
            imgObj.crossOrigin = "anonymous";

            //Set the src of this Image object.
            imgObj.src = dataUrl;

            //When our image has loaded.
            imgObj.onload = function () {
                //Draw the image onto the canvas.
                //_this.state.canvas.width = imgObj.width;
                //_this.state.canvas.height = imgObj.height;
                //_this.state.context.fillStyle = "#FFFFFF";
                //_this.state.context.fillRect(0, 0, _this.state.canvas.width, _this.state.canvas.height);
                _this.state.context.drawImage(imgObj, x, y);
            }

            this.setState({ loadedImage: imgObj });
        }
        
    }

    redraw() {
        // Clear the entire canvas
        var p1 = this.state.context.transformedPoint(0,0);
        var p2 = this.state.context.transformedPoint(this.state.canvas.width, this.state.canvas.height);
        this.state.context.clearRect(p1.x,p1.y,p2.x-p1.x,p2.y-p1.y);

        this.state.context.save();
        this.state.context.setTransform(1,0,0,1,0,0);
        this.state.context.clearRect(0,0, this.state.canvas.width, this.state.canvas.height);
        this.state.context.restore();

        this.loadCanvas(this.props.image)

    }

    getColorByMouse(e) {
        var pos = this.findPos();

        if (pos) {
            var x = e.pageX - pos.x;
            var y = e.pageY - pos.y;
            var c = document.getElementById('my_canvas').getContext('2d');
            var p = c.getImageData(x, y, 1, 1).data; // RGB

            var color = window.Color().fromRgb( { r: p[0], g: p[1], b: p[2] } );

            this.setState({
                red: p[0],
                blue: p[1],
                green: p[2],
                hex: color.toString(),
                hsv: color.toHsv()
            })
        }
    }

    findPos() {
        var curleft = 0, curtop = 0;
        var tempCanvas = this.state.canvas;
        if (tempCanvas) {
            do {
                curleft += tempCanvas.offsetLeft;
                curtop += tempCanvas.offsetTop;
                // eslint-disable-next-line
            } while (tempCanvas = tempCanvas.offsetParent);
            return { x: curleft, y: curtop };
        }
        return undefined;
    }

    clickMedian() {
        if (!this.state.medianBlur) {
            let src = window.cv.imread('my_canvas');
            let dst = new window.cv.Mat();
            // You can try more different parameters
            window.cv.medianBlur(src, dst, 19);
            window.cv.imshow('my_canvas', dst);
            src.delete(); dst.delete();

            this.setState({medianBlur: true})
        } else {
            this.redraw();
            this.setState({medianBlur: false})
        }

    }

    handleChange(event, setting) {
        let temp = this.state.settings;
        temp[setting] = event.target.value;
        this.setState({ settings: temp });
    }

    storeHsv(event) {
        this.setState({ hsvSaved: this.state.hsv });
        this.setState({ hexSaved: this.state.hex });
        this.requestPigments(this.state.hsv);
        //this.state.clickAudio.play();

        var tempHistory = this.state.hexHistory;

        tempHistory.push(this.state.hex);
        if (tempHistory.length > 15) {
            tempHistory = tempHistory.slice(-15);
        }
        this.setState({ hexHistory: tempHistory });
    }

    requestPigments(hsv) {
        var _this = this;
        this.setState({ loadingPigments: true });
        axios.get(
                //'http://localhost:5001/alerionart-192803/us-central1/getPigments', 
                'https://us-central1-alerionart-192803.cloudfunctions.net/getPigments',
                {
                    params: {
                        hue: hsv.h,
                        value: hsv.v,
                        saturation: hsv.s
                    }
                }
            )
            .then(function (response) {
                _this.setState({ loadingPigments: false });
                _this.setState({
                    huePigments: response.data.huePigments,
                    neutralPigments: response.data.neutralPigments
                })
            })
            .catch(function (error) {
                console.log(error);
                _this.setState({ loadingPigments: false });
            });
    }

    addToCart(pigment) {
        let found = this.state.cart.find((item) => item === pigment );
        if (!found) {
            this.setState({ cart: [ ...this.state.cart, pigment ] });
        }
    }

    removeFromCart(pigment) {
        let cart = this.state.cart.filter((item) => item !== pigment );
        this.setState({ cart: cart });
    }

    addToPalette(color) {
        var tempPalette = this.state.palette;

        tempPalette.push(color);
        if (tempPalette.length > 5) {
            tempPalette = tempPalette.slice(-5);
        }
        this.setState({ palette: tempPalette });
    }

    restoreSaved(event = null, color) {
        color = window.Color().fromHex(color);
        // Make sure event it targeted on proper divs, not svg or .remove-pigment
        if (event === null 
            || (typeof event.target.className.baseVal === 'undefined' 
                && event.target.className.search('pigment ') >= 0)
        ) {
            this.setState({ hexSaved: color });

            this.setState({ hsvSaved: color.toHsv() });
            this.requestPigments(color.toHsv());
        }

        /*this.setState({
            red: rgb.r,
            blue: rgb.b,
            green: rgb.g,
            hex: color,
            hsv: hsv
        })*/
    }

    handleMouseClick(color) {
        if (this.state.tool === 'dropper') {
            this.restoreSaved(null, color);
        } else if (this.state.tool === 'palette') {
            this.addToPalette(color);
        }
    }

    handleCanvasClick(event) {
        if (this.state.tool === 'dropper') {
            this.storeHsv(event);
        } else if (this.state.tool === 'palette') {
            this.addToPalette(this.state.hex);
        }
    }

    changeTool(tool) {
        this.setState({ tool: tool });
    }

    toggleCart() {
        this.setState({ cartOpen: !this.state.cartOpen })
    }

    removePigment(index) {
        let palette = this.state.palette.filter((item, itemIndex) => itemIndex !== index );
        this.setState({ palette: palette });
    }

    trackTransforms(context){
        var svg = document.createElementNS("http://www.w3.org/2000/svg",'svg');
        var xform = svg.createSVGMatrix();
        context.getTransform = function(){ return xform; };
  
        var savedTransforms = [];
        var save = context.save;
        context.save = function(){
            savedTransforms.push(xform.translate(0,0));
            return save.call(context);
        };
      
        var restore = context.restore;
        context.restore = function(){
          xform = savedTransforms.pop();
          return restore.call(context);
        };
  
        var scale = context.scale;
        context.scale = function(sx,sy){
          xform = xform.scaleNonUniform(sx,sy);
          return scale.call(context,sx,sy);
        };
      
        var rotate = context.rotate;
        context.rotate = function(radians){
            xform = xform.rotate(radians*180/Math.PI);
            return rotate.call(context,radians);
        };
      
        var translate = context.translate;
        context.translate = function(dx,dy){
            xform = xform.translate(dx,dy);
            return translate.call(context,dx,dy);
        };
      
        var transform = context.transform;
        context.transform = function(a,b,c,d,e,f){
            var m2 = svg.createSVGMatrix();
            m2.a=a; m2.b=b; m2.c=c; m2.d=d; m2.e=e; m2.f=f;
            xform = xform.multiply(m2);
            return transform.call(context,a,b,c,d,e,f);
        };
      
        var setTransform = context.setTransform;
        context.setTransform = function(a,b,c,d,e,f){
            xform.a = a;
            xform.b = b;
            xform.c = c;
            xform.d = d;
            xform.e = e;
            xform.f = f;
            return setTransform.call(context,a,b,c,d,e,f);
        };
      
        var pt = svg.createSVGPoint();
        context.transformedPoint = function(x,y){
            pt.x=x; pt.y=y;
            return pt.matrixTransform(xform.inverse());
        }
    }

    render() {
        //onMouseMove={this.getColorByMouse} onClick={this.handleCanvasClick}
        return (
            <div className="max-w-7xl mx-auto">
                <div className="App mb-2">
                    <div className="flex">
                        <div className="h-screen flex-1 mx-2 border border-gray-500">
                            <canvas id="my_canvas" className={classNames({ 'cursor-dropper': (this.state.tool === 'dropper') }, { 'cursor-palette': (this.state.tool === 'palette') }, { 'cursor-move': (this.state.tool === 'move') }, 'border', 'shadow-lg')} width="600" height="879" ></canvas>
                        </div>
                        <div className="flex-1 mx-2">
                            {/*<Stats hsv={this.state.hsv} 
                            hsvSaved={this.state.hsvSaved}
                            ></Stats>*/}
                            <div className="flex items-center">
                                <div className="mr-4 flex items-center">
                                    <span role="checkbox" tabIndex="0" onClick={this.clickMedian} aria-checked="false" className={(this.state.medianBlur) ? "bg-teal-600 relative inline-flex flex-shrink-0 h-6 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline" : "bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"}>
                                        <span aria-hidden="true" className={(this.state.medianBlur) ? "translate-x-6 inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200" : "translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"}></span>
                                    </span> 
                                    <span className="ml-4 text-sm leading-5 font-medium text-gray-600 mb-1">Poster Study</span>
                                </div>
                                <div className="mr-4 flex items-center" onClick={() => this.changeTool('dropper')}>
                                    <div className={classNames({ 'shadow-outline': (this.state.tool === 'dropper') }, 'inline-flex', 'items-center', 'justify-center', 'p-1', 'border', 'border-transparent', 'text-base', 'rounded-md', 'bg-white', 'focus:outline-none', 'focus:shadow-outline', 'transition', 'duration-150', 'ease-in-out', 'cursor-pointer')}>
                                        <img src="images/dropper.png" alt="Eye Dropper" className="h-5 w-5" />
                                    </div>
                                    <span className="ml-3 text-sm leading-5 font-medium text-gray-600 mb-1">Eye Dropper</span>
                                </div>
                                <div className="mr-4 flex items-center" onClick={() => this.changeTool('palette')}>
                                    <div className={classNames({ 'shadow-outline': (this.state.tool === 'palette') }, 'inline-flex', 'items-center', 'justify-center', 'p-1', 'border', 'border-transparent', 'text-base', 'rounded-md', 'bg-white', 'focus:outline-none', 'focus:shadow-outline', 'transition', 'duration-150', 'ease-in-out', 'cursor-pointer')}>
                                        <img src="images/palette-knife.png" alt="Palette Knife" className="h-5 w-5" />
                                    </div>
                                    <span className="ml-3 text-sm leading-5 font-medium text-gray-600 mb-1">Palette Knife</span>
                                </div>
                                <div className="flex items-center" onClick={() => this.changeTool('move')}>
                                    <div className={classNames({ 'shadow-outline': (this.state.tool === 'move') }, 'inline-flex', 'items-center', 'justify-center', 'p-1', 'border', 'border-transparent', 'text-base', 'rounded-md', 'bg-white', 'focus:outline-none', 'focus:shadow-outline', 'transition', 'duration-150', 'ease-in-out', 'cursor-pointer')}>
                                        <img src="images/move.png" alt="Move Tool" className="h-5 w-5" />
                                    </div>
                                    <span className="ml-3 text-sm leading-5 font-medium text-gray-600 mb-1">Move</span>
                                </div>
                            </div>
                            <Pigments hex={this.state.hex}
                                hexSaved={this.state.hexSaved}
                                hsv={this.state.hsv}
                                hsvSaved={this.state.hsvSaved}
                                addToPalette={this.addToPalette}
                                tool={this.state.tool}
                            ></Pigments>
                            <History history={this.state.hexHistory} 
                                handleClick={this.handleMouseClick}
                                tool={this.state.tool}
                            ></History>
                            <div className="flex">
                                <Palette palette={this.state.palette} 
                                    handleClick={this.restoreSaved}
                                    removePigment={this.removePigment}
                                    tool={this.state.tool}
                                ></Palette>
                                <Oils addToCart={this.addToCart}
                                    loading={this.state.loadingPigments}
                                    huePigments={this.state.huePigments}
                                    neutralPigments={this.state.neutralPigments} />
                            </div>
                        </div>
                        <div class="absolute bottom-0 right-0 bg-white rounded px-4 py-2 mr-8 mb-8 shadow overflow-hidden transition ease-in-out duration-200" >
                            { this.state.cartOpen ? (
                                    <div>
                                        <ul>
                                            {
                                                this.state.cart.map((pigment, index) => (
                                                    <li key={index} className="flex justify-between my-1">
                                                        <div class="block hover:bg-gray-100 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                                                            { pigment }
                                                        </div>
                                                        <div class="h-5 flex items-center">
                                                            <button onClick={() => this.removeFromCart(pigment)} aria-label="Remove from Cart" class="text-gray-400 hover:text-gray-500 transition ease-in-out duration-150">
                                                                <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                        <div className="mt-1 flex justify-between border-t py-2">
                                            <div className="mr-8">{ this.state.cart.length} Pigments</div>
                                            <div className="cursor-pointer underline text-teal-500"><Link to="/checkout">Checkout</Link></div>
                                        </div>
                                        <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150" id="options-menu" aria-haspopup="true" aria-expanded="true" onClick={this.toggleCart}>
                                            <svg class="-mr-1 ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                ) : (
                                    <div className="flex justify-between">
                                        <button type="button" class="rounded-full text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-800 transition ease-in-out duration-150" id="options-menu" aria-haspopup="true" aria-expanded="true" onClick={this.toggleCart}>
                                            <svg class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" transform="scale(1, -1) translate(0, -20)" />
                                            </svg>
                                        </button>
                                        <span class="ml-2 cursor-pointer font-bold shadow inline-flex items-center px-3 py-1 rounded-full text-sm leading-5 bg-green-100 text-green-800"  onClick={this.toggleCart}>
                                            View Cart: { this.state.cart.length}
                                        </span>
                                    </div>
                                )
                            }
                        </div>

                        {/*
                        <div>
                            <h4 className="mt-4 mb-4 font-bold">Value/Chroma Ranges</h4><hr />
                            <div>
                            Low Value:<br />
                            <input type="text" value={this.state.settings.lowValue} onChange={(e) => this.handleChange(e, 'lowValue')} className="border" />
                            </div>
                            <div>
                            Middle Value:<br />
                            <input type="text" value={this.state.settings.middleValue} onChange={(e) => this.handleChange(e, 'middleValue')} className="border"  />
                            </div>
                            <div>
                            Low Chroma:<br />
                            <input type="text" value={this.state.settings.lowChroma} onChange={(e) => this.handleChange(e, 'lowChroma')} className="border"  />
                            </div>
                            <div>
                            Middle Chroma:<br />
                            <input type="text" value={this.state.settings.middleChroma} onChange={(e) => this.handleChange(e, 'middleChroma')} className="border"  />
                            </div>
                            <h4 className="mt-4 mb-4 font-bold">Hue Ranges (Lower Threshold)</h4><hr />
                            <div className="flex mt-4">
                            <div className="w-10">Red:</div> 
                            <input type="text" value={this.state.settings.r} onChange={(e) => this.handleChange(e, 'r')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Crimson:</div> 
                            <input type="text" value={this.state.settings.pr} onChange={(e) => this.handleChange(e, 'pr')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Violet:</div> 
                            <input type="text" value={this.state.settings.p} onChange={(e) => this.handleChange(e, 'p')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Blue/Violet:</div> 
                            <input type="text" value={this.state.settings.bp} onChange={(e) => this.handleChange(e, 'bp')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Blue:</div> 
                            <input type="text" value={this.state.settings.b} onChange={(e) => this.handleChange(e, 'b')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">GreenBlue:</div> 
                            <input type="text" value={this.state.settings.gb} onChange={(e) => this.handleChange(e, 'gb')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Green:</div> 
                            <input type="text" value={this.state.settings.g} onChange={(e) => this.handleChange(e, 'g')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Green Yellow:</div> 
                            <input type="text" value={this.state.settings.gy} onChange={(e) => this.handleChange(e, 'gy')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Yellow(Cad/Ochre):</div> 
                            <input type="text" value={this.state.settings.y} onChange={(e) => this.handleChange(e, 'y')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Orange/Yellow:</div> 
                            <input type="text" value={this.state.settings.oy} onChange={(e) => this.handleChange(e, 'oy')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Orange:</div> 
                            <input type="text" value={this.state.settings.o} onChange={(e) => this.handleChange(e, 'o')} className="w-10 border" />
                            </div>
                            <div className="flex">
                            <div className="w-10">Red/Orange:</div> 
                            <input type="text" value={this.state.settings.ro} onChange={(e) => this.handleChange(e, 'ro')} className="w-10 border" />
                            </div>
                        </div>
                        */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Picker;
